import { toast } from 'sonner';
import { messageFor } from '@/api/errors';

/**
 * Toasts, in one place so the panel's voice stays consistent.
 *
 * Success messages use the past tense of the verb on the button that caused
 * them — "Publish" produces "Published" — so an admin can tell at a glance that
 * what they asked for is what happened.
 */
export const notify = {
  success(message: string, description?: string): void {
    toast.success(message, { description });
  },

  /** Failures carry the stable error code, so a support conversation has one. */
  error(error: unknown, fallback?: string): void {
    toast.error(fallback ?? 'That did not work', { description: messageFor(error) });
  },

  info(message: string, description?: string): void {
    toast(message, { description });
  },
};
